<template>
    <div class="batch-import-wrapper">
        <div class="batch-import-top flex-c margin-b20">
             <div v-for="(item,index) in stepData" :key="index" class="flex">
                 <div class="step-box">
                     <div class="circle-box">{{index +1 }}</div>
                     <div class="tip-box">{{item}}</div>
                 </div>
                 <div class="line-box" v-if="index !== 3"></div>
             </div>
        </div>
        <div class="batch-import-bottom">
            <div class="upload-title margin-b20">上传文件</div>

            <div v-show="!appendixName">
                <el-upload
                        ref="upload"
                        accept=".xls,.xlsx"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :headers="headers"
                        :show-file-list="false"
                        :auto-upload="false"
                        :on-success="getFileInfo"
                        :on-change="onChange">
                    <div class="flex-start">
                        <div class="choose-file margin-b10">选择文件</div>
                    </div>
                </el-upload>
            </div>
            <div v-show="appendixName" class="word-show">
                    <div>
                        <div class="write"></div>
                        <span>{{ appendixName }}</span>
                    </div>
                    <div class="close" @click="deleteFile"></div>
            </div>

            <div class="little-tip">如无可用模版，请先<span style="color: #126EDF;cursor: pointer" @click="categoryDownloadTemplate">下载物料分类映射模版</span></div>
            <div class="warm-tip">
                <div>温馨提示：</div>
                <div>1.excel格式必须是或者xlsx或者xIs，条数≤10000条。</div>
                <div>2.必填字段不能为空（必填字段名称前面带*），否则将导入失败。</div>
            </div>
<!--            v-permission="['/product/purchaseCategory/batchUpload']"-->
            <div class="flex-c" >
                <div class="choose-file" @click="handleUpload">上&nbsp;传</div>
            </div>
        </div>

    </div>
</template>

<script>
    import api from '@/modules/projectA/api/purchase';
    import utils from "../../../utils/utils";
    import { epecToken } from '../../../utils/globalData';
    export default {
        name: "batchImport",
        data(){
            return{
                action:api.batchUpload,
                headers: epecToken,
                appendixName:'',//文件名称
                file:Object,
                isActive:4,
                stepData:['下载模版','维护表内容','上传表','完成'],
            }
        },
        methods:{
            deleteFile(){
                this.$refs.upload.clearFiles();
                this.appendixName = '';
            },
            handleUpload(){

                if(!this.file.raw){
                    this.$message.warning('请选择要上传的文件。');
                    return false;
                }

                // 通过 FormData 对象上传文件
                const file = new FormData();
                file.append("file", this.file.raw);
                 api.categoryBatchUpload(file).then(res => {
                        if (res.success) {
                           this.$message.success('文件上传成功。')
                        }
                    })
            },
            onChange(file, fileList){
                const fileNameArr = file.name.split('.');
                const arr = ['xls', 'xlsx'];
                if (!arr.includes(fileNameArr[fileNameArr.length - 1])) {
                    this.$message({
                        message: '请上传excel格式的附件。',
                        type: 'warning',
                    });
                    return false;
                }
                this.file = file;
                this.appendixName = file.name;
            },
            //文件上传成功
            getFileInfo(res) {
                if (res.success) {
                    this.appendixName = res.data.fileName;
                }
            },
            categoryDownloadTemplate(){
                api.categoryDownloadTemplate().then(res => {
                    if (res.size !== 0) {
                        utils.downFile(res, `物料分类映射模板`);
                    }
                });
            },
        },
    }
</script>

<style scoped lang="scss">
.batch-import-wrapper{
    width: 100%;
    height: 412px;
    background: #FFF;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding:  0 20px;
    .batch-import-top{
        height: 114px;
        padding-top: 30px;
        border-bottom: 1px solid #D9D9D9;
        .step-box{
            width: 82px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            .circle-box{
                width: 30px;
                height: 30px;
                line-height: 30px;
                background: #2587FF;
                border-radius: 50%;
                color: #FFFFFF;
                text-align: center;
                margin-bottom: 10px;
            }
            .tip-box{
                color: #333;
            }
        }
        .line-box{
            width: 140px;
            height: 15px;
            border-bottom: 2px solid #2587FF;
        }
    }
    .batch-import-bottom{
        margin-left: 10px;
        .upload-title{
            font-size: 18px;
        }
        .word-show {
            width: 410px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            height: 20px;
            white-space: normal;
            flex-basis: 49%;
            position: relative;
            padding-left: 30px;
            margin-bottom: 20px;
            .write {
                position: absolute;
                left: 4px;
                top: 2px;
                background: url("../../../../../assets/img/write-gray.png") no-repeat center center;
                background-size: 12px;
            }
            &:hover .write {
                background: url("../../../../../assets/img/write.png") no-repeat center center;
                background-size: 12px;
            }
            .close {
                position: absolute;
                right: 4px;
                top: 4px;
                background: url("../../../../../assets/img/success.png") no-repeat center center;
                background-size: 12px;
            }
            &:hover {
                background-color: #f4f7ff;
            }
            &:hover .close {
                background: url("../../../../../assets/img/close.png") no-repeat center center;
                background-size: 10px;
            }
            img {
                width: 12px;
                height: 16px;
                margin: -2px 12px;
            }
            span {
                color: #0064c8;
                font-size: 14px;
            }
            .close {
                width: 12px;
                height: 12px;
                cursor: pointer;
            }
            .write {
                width: 12px;
                height: 16px;
                cursor: pointer;
            }
        }
        .choose-file{
            width: 120px;
            height: 30px;
            line-height: 30px;
            background: #2587FF;
            color: #FFF;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            &:hover{
                background-color: #0064c8;
            }
         }
        .little-tip{
            font-weight: 350;
            font-size: 14px;
            color: #333;
            margin-bottom: 30px;
        }
        .warm-tip{
            color: #999;
            font-size: 14px;
            margin-bottom: 30px;
           div{
               margin-bottom: 2px;
           }
        }

    }
}
</style>